module.exports = __webpack_public_path__ + "static/ogp-contact-twitter-ea66a9411a2e46b50b95c2770608069a.png";